import { findIndex, filter } from "lodash";
import * as actionType from "./ActionTypes";

export default function ContainerArrivalReportReducer(state = {}, action) {
  const { payload } = action;
  switch (action.type) {
    case actionType.ARRIVAL_REPORT_LOAD:
      return (state = payload);
    case actionType.ARRIVAL_REPORT_GATE_IN:
      var finalGateInPayload = [...state];
      const findId = findIndex(state, (data) => {
        return (
          data.TransporterDataId.toString() === payload.Id.toString()
        );
      });
      for (let i = 0; i < state.length; i++) {
        if(state[i].TransporterDataId.toString() === payload.Id.toString()){
          finalGateInPayload[findId]={
            ...state[i],
            Gate_In_Date : payload.value
          }
        }
      }
      return finalGateInPayload;
    case actionType.ARRIVAL_DELETE_ROW:
      for (let i = 0; i < payload.deleteIdPayload.length; i++) {
        state = filter(state, function (datas) {
          return datas.ContainerMasterId !== parseInt(payload.deleteIdPayload[i]);
        });
      }
      // if(state.length === 0){
        payload.statePayload(state)
      // }
      return state;
    default:
      return state;
  }
}
